import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useGeneralContext } from "../../Contexts/GeneralContext/GeneralProvider";
import SessionStatusScreen from "../../Components/SharedComponents/OtherComponents/SessionStatusScreen";

// Waits while the session is still being restored instead of treating "not loaded yet"
// as "logged out", which is what used to bounce users off their page on every reload.
function ProtectedRoute({ children }: { children: ReactNode }) {

	const { authStatus, isRetryingSession, restoreSession } = useGeneralContext()

	if (authStatus === 'unknown' || authStatus === 'error') {
		return (
			<SessionStatusScreen
				isRetrying={isRetryingSession}
				hasFailed={authStatus === 'error'}
				onRetry={restoreSession}
			/>
		)
	}

	if (authStatus === 'anonymous') {
		return <Navigate to="/login" replace />
	}

	return <>{children}</>
}

export default ProtectedRoute
